import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayCashPendingIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M9.58997 14.12L8.33997 15.26C9.03997 16.03 9.96997 16.6 11.37 16.72V18H12.96V16.66C14.81 16.35 15.68 15.2 15.68 13.83C15.68 12.46 14.75 11.62 12.8 11.17V8.85999C13.47 9.00999 13.91 9.31999 14.25 9.68999L15.52 8.54999C14.91 7.84999 14.09 7.41999 12.97 7.29999V5.98999H11.38V7.29999C9.57997 7.50999 8.61997 8.47999 8.61997 9.93999C8.61997 11.29 9.46997 12.21 11.56 12.64V15.15C10.78 15.04 10.13 14.66 9.59997 14.11L9.58997 14.12ZM12.79 12.93C13.58 13.17 13.75 13.58 13.75 13.99C13.75 14.52 13.44 14.95 12.79 15.13V12.93ZM10.53 9.89999C10.53 9.35999 10.84 8.97999 11.55 8.83999V10.9C10.84 10.7 10.53 10.43 10.53 9.89999Z"
        fill={color}
      />
      <path
        d="M12 0.25C11.59 0.25 11.25 0.59 11.25 1C11.25 1.41 11.59 1.75 12 1.75C17.65 1.75 22.25 6.35 22.25 12C22.25 17.65 17.65 22.25 12 22.25C11.59 22.25 11.25 22.59 11.25 23C11.25 23.41 11.59 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25Z"
        fill={color}
      />
      <path
        d="M1.79001 12.9C1.76001 12.61 1.75001 12.31 1.75001 12C1.75001 11.7 1.76001 11.4 1.79001 11.11C1.83001 10.7 1.52001 10.33 1.11001 10.3C0.69001 10.26 0.33001 10.57 0.30001 10.98C0.27001 11.31 0.26001 11.65 0.26001 11.99C0.26001 12.34 0.27001 12.68 0.30001 13.02C0.33001 13.41 0.66001 13.71 1.05001 13.71C1.07001 13.71 1.09001 13.71 1.12001 13.71C1.53001 13.67 1.84001 13.31 1.80001 12.9H1.79001Z"
        fill={color}
      />
      <path
        d="M1.69999 8.05001C2.06999 8.22001 2.51999 8.07001 2.69999 7.69001C2.94999 7.15001 3.24999 6.63001 3.58999 6.15001C3.82999 5.81001 3.73999 5.34001 3.39999 5.11001C3.05999 4.87001 2.58999 4.96001 2.35999 5.30001C1.96999 5.86001 1.62999 6.45001 1.33999 7.07001C1.16999 7.45001 1.32999 7.89001 1.69999 8.07001V8.05001Z"
        fill={color}
      />
      <path
        d="M7.63997 21.28C7.09997 21.03 6.58997 20.73 6.09997 20.38C5.75997 20.14 5.28997 20.22 5.05997 20.56C4.81997 20.9 4.89997 21.37 5.23997 21.6C5.79997 21.99 6.38997 22.34 6.99997 22.63C7.36997 22.8 7.81997 22.65 7.99997 22.27C8.17997 21.9 8.01997 21.45 7.63997 21.27V21.28Z"
        fill={color}
      />
      <path
        d="M2.69998 16.33C2.52998 15.95 2.07998 15.79 1.69998 15.97C1.31998 16.14 1.15998 16.59 1.33998 16.97C1.62998 17.59 1.96998 18.18 2.35998 18.74C2.59998 19.08 3.06998 19.16 3.39998 18.92C3.73998 18.68 3.81998 18.21 3.57998 17.88C3.23998 17.39 2.93998 16.87 2.68998 16.34L2.69998 16.33Z"
        fill={color}
      />
      <path
        d="M5.65996 3.75999C5.80996 3.75999 5.95996 3.71999 6.08996 3.61999C6.56996 3.27999 7.08996 2.97999 7.62996 2.71999C8.00996 2.53999 8.16996 2.09999 7.98996 1.71999C7.80996 1.33999 7.36996 1.18999 6.98996 1.35999C6.36996 1.64999 5.77996 1.99999 5.22996 2.38999C4.88996 2.62999 4.80996 3.09999 5.04996 3.43999C5.19996 3.64999 5.42996 3.75999 5.65996 3.75999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayCashPendingIcon.displayName = 'PayCashPendingIcon';
